import React, { FC, useMemo } from 'react';

import { ItemWidth, ResponsiveCarousel } from 'components/responsive-carousel';
import { useIsMobileBreakpoint } from 'hooks/use-media-query';

import { RewardsCarouselCard } from './rewards-carousel-card';
import { CarouselReward, IRewardsCarouselProps } from './types';

const rewardsBenefitIdKeyExtractor = (item: CarouselReward) => item.rewardBenefitId;

const rewardsItemRenderer = ({ item }: { item: CarouselReward }) => (
  <RewardsCarouselCard reward={item} />
);

/**
 * A carousel for loyalty rewards
 */

export const RewardsCarousel: FC<React.PropsWithChildren<IRewardsCarouselProps>> = ({
  rewards,
}) => {
  const isMobile = useIsMobileBreakpoint();
  const itemWidth = isMobile
    ? ItemWidth.VERTICAL_CAROUSEL_ITEM_MOBILE
    : ItemWidth.VERTICAL_CAROUSEL_ITEM_DESKTOP_LARGE;

  return (
    <ResponsiveCarousel
      centerCards={false}
      bgColor="transparent"
      data={useMemo(() => rewards.filter(reward => reward.isAvailable), [rewards])}
      itemWidth={itemWidth}
      keyExtractor={rewardsBenefitIdKeyExtractor}
      renderItem={rewardsItemRenderer}
      loop={false}
      inactiveSlideOpacity={1}
      inactiveSlideScale={0.9}
    />
  );
};
